import createTag from './createTag';
import deleteTag from './deleteTag';
import getTags from './getTags';
import updateTag from './updateTag';
import renderTagPreview from './renderTagPreview';

export default {
  createTag,
  deleteTag,
  getTags,
  updateTag,
  renderTagPreview,
};
